<template>
  <v-card>
    <v-card-title class="text-h5">
      Login Olhadela
      <v-spacer />
      <v-btn icon @click="$emit('logged')"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pt-4">
      <v-form ref="loginForm">
        <v-text-field
          v-model="user.email"
          :rules="[$rules.required, $rules.email]"
          label="E-mail"
          outlined
          dense
        />
        <v-text-field
          v-model="user.password"
          :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[$rules.required, $rules.passwordMin]"
          :type="showPass ? 'text' : 'password'"
          label="Senha"
          @click:append="showPass = !showPass"
          outlined
          dense
        />

        <v-alert
          v-model="passworderror"
          type="warning"
          transition="scale-transition"
        >
          Senha incorreta
        </v-alert>
        <v-alert
          v-model="emailerror"
          type="warning"
          transition="scale-transition"
        >
          E-mail incorreto
        </v-alert>
        <v-alert
          v-model="erroralert"
          type="error"
          transition="scale-transition"
        >
          Um erro inesperado aconteceu, contate-nos ou tente novamente mais
          tarde
        </v-alert>

        <div
          class="d-flex flex-wrap flex-row-reverse align-center justify-start"
        >
          <v-btn color="#4B2A66" dark @click="login"> Entrar </v-btn>
          <a
            style="color:#4B2A66"
            text
            @click="forgotPasswordDialog = true"
            class="ma-3 text-decoration-none text-decoration-underline"
            small
          >
            Esqueceu sua senha?
          </a>
        </div>

        <v-divider class="my-4" />

        <v-btn
          class="my-2"
          large
          block
          tile
          outlined
          color="pink darken-4"
          dark
          :to="{ name: 'register-user' }"
        >
          Criar conta com email
        </v-btn>
        <!--<v-btn class="my-2" large block tile outlined color="red">
          <v-icon left>mdi-google</v-icon> Conectar com o Google
        </v-btn>
        <v-btn
          class="my-2"
          large
          block
          tile
          outlined
          color="primary"
          @click="facebookLogin"
        >
          <v-icon left>mdi-facebook</v-icon> Conectar com o Facebook
        </v-btn>-->
      </v-form>

      <v-dialog v-model="forgotPasswordDialog" persistent max-width="500px">
        <v-card>
          <v-card-title class="justify-center">
            <span class="headline">Recuperação de senha</span>
          </v-card-title>
          <v-card-text class="pb-0">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div
                    class="black--text text-center text-body-1 font-weight-medium"
                  >
                    Informe um endereço de Email para redefinir sua senha
                  </div>
                  <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    v-model="forgot_password.email"
                    label="Informe seu E-mail"
                    :rules="[$rules.required, $rules.email]"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-alert
            v-model="recoverysuccess"
            type="success"
            transition="scale-transition"
          >
            Código enviado para o seu email!
          </v-alert>
          <v-alert
            v-model="recoveryerror"
            type="warning"
            transition="scale-transition"
          >
            E-mail incorreto
          </v-alert>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="#4B2A66"
              text
              @click="forgotPasswordDialog = false"
            >
              Cancelar
            </v-btn>
            <v-btn color="#4B2A66" text @click="passwordrecovery">
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Login",
  data: () => ({
    user: {
      email: "",
      password: "",
    },
    forgot_password: {
      email: "",
    },
    showPass: false,
    forgotPasswordDialog: false,
    passworderror: false,
    emailerror: false,
    erroralert: false,
    recoveryerror: false,
    recoverysuccess: false,
    passwordCode: false,
    panel: [0],
    readonly: true,
  }),
  methods: {
    facebookLogin() {},
    resetValidation() {
      this.$refs.loginForm.resetValidation();
    },
    login() {
      if (this.$refs.loginForm.validate()) {
        this.passworderror = false;
        this.emailerror = false;
        this.erroralert = false;
        this.$axios
          .put("/login", this.user)
          .then((response) => {
            this.$store.commit("setUser", response.data);
            this.$emit("logged");
            this.$refs.loginForm.reset();
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 401) {
                this.passworderror = true;
              } else if (error.response.status == 404) {
                this.emailerror = true;
              } else {
                this.erroralert = true;
              }
            }
          });
      }
    },
    passwordrecovery() {
      this.recoveryerror = false;
      this.recoverysuccess = false;
      this.$axios
        .put("/forgot-password/" + this.forgot_password.email)
        .then(() => {
          this.recoverysuccess = true;
          this.$router.replace({
            name: "newPassword",
          });
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 422) {
              this.recoveryerror = true;
            } else {
              this.erroralert = true;
            }
          }
        });
    },
  },
};
</script>
